export const TargetMenuModalTranslationEN = {};
